import { ClientError } from "../ClientError.js";
import { useSystemGraphQlClient } from "./useSystemGraphQlClient.js";
import { useProjectSlug } from "../project/useProjectSlug.js";
const useCurrentSystemGraphQlClient = () => {
  const projectSlug = useProjectSlug();
  if (projectSlug === void 0) {
    throw new ClientError(`Cannot contact the system API: undefined project slug.`);
  }
  return useSystemGraphQlClient(projectSlug);
};
export {
  useCurrentSystemGraphQlClient
};
//# sourceMappingURL=useCurrentSystemGraphQlClient.js.map
